<template>
  <div id="quesList">
    <!-- 预览文件的地方（用于渲染） -->
    <van-cell-group class="navShow">
      <van-row>
        <van-col :span="3" style="font-size:.6rem;position:relative;top:3px;">
          <van-icon name="arrow-left" color="#fff" @click="back" />
        </van-col>
        <van-col :span="18">常见问题</van-col>
        <van-col :span="2"></van-col>
      </van-row>
    </van-cell-group>
    <div class="docxCon">
      <!-- <div id="container">
				<div v-for="page in pages" :key="page" ref="pageContainer" style="width:100%;height:100%;overflow:auto">
					<canvas v-if="renderList.includes(page)" width="width:100%;"></canvas>
				</div>
      </div>-->
      <!-- <a href="./pdfjs/web/常见问题及解决 .pdf" target="_blank">下载</a> -->
      <div id="pdfCon">
        <iframe class="pdf_iframe" src="/pdfjs/web/viewer.html?file=question.pdf"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import pdfJS from "pdfjs-dist";
import AlloyFinger from "@/assets/js/alloyFinger.js";
import transform from "@/assets/js/transform.js";
import To from "@/assets/js/to.js";
export default {
  name: "quesList",
  props: {
    renderPages: {
      // 前后各预渲染多少页
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      baseUrl: sessionStorage.getItem("baseURL")
    };
  },

  created() {},
  beforeDestroy() {},
  mounted() {
    this.$nextTick(() => {
      $(".pdf_iframe").on("load", function() {
        $(".pdf_iframe")
          .contents()
          .find("body")
          .find("#viewerContainer")
          .css("top", "0");
        $(".pdf_iframe")
          .contents()
          .find("body")
          .find(".toolbar")
          .hide();
	  });
	  this.setTransform()
    });
  },
  methods: {
	//   //绑定触屏事件
    // addPinchListener() {
    //   let element = document.getElementById("pdf_iframe");
    //   element.addEventListener("touchstart", onTouchStart, false);
    //   element.addEventListener("touchmove", onTouchMove, false);
    //   element.addEventListener("touchend", onTouchEnd, false);
    // },
    setTransform() {
      let element = document.getElementById("pdfCon");
      Transform(element);
      var initScale = 1;
      new AlloyFinger(element, {
        multipointStart: function() {
          initScale = element.scaleX;
        },
        pinch: function(evt) {
          //实现缩放
          element.scaleX = element.scaleY = initScale * evt.scale;
        },
        pressMove: function(evt) {
          //实现移动
          element.translateX += evt.deltaX;
          element.translateY += evt.deltaY;
          // evt.preventDefault();
        }
      });
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.navShow {
  width: 100%;
  height: 1.25rem;
  line-height: 1.25rem;
  z-index: 1;
}
.navShow .van-row {
  height: 100%;
}
.navShow .van-row .van-col {
  height: 100%;
  text-align: center;
  color: #fff;
  font-size: 0.45rem;
}
.docxCon {
  height: calc(100% - 1.25rem);
  overflow: auto;
}
#pdfCon,
.pdf_iframe {
  width: 100%;
  height: 100%;
}
.pdf_iframe >>> .toolbar {
  display: none;
}
</style>
<style>
#viewerContainer {
  top: 0;
}
</style>
